








































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';
import Status from '@/web/components/customers/Status.vue';

export default Vue.extend({
  name: 'CustomerDetailGroups',
  components: {
    Status,
  },
  computed: {
    ...mapGetters({
      teacherStudioUrl: 'user/teacherStudioUrl',
      teacherMagicCode: 'user/teacherMagicCode',
    }),
    getUserId() {
      return parseInt(this.$route.params.id);
    },
    customerGroupsQuery() {
      return {
        customerId: this.getUserId,
      };
    },
  },
  data() {
    return {
      customerGroupsFields: [
        {
          name: 'group_name',
          title: this.$t('CUSTOMERS.TABLE.GROUP_NAME'),
          cssClass: 'h5',
        },
        {
          name: 'group_status',
          title: this.$t('CUSTOMERS.TABLE.GROUP_STATUS'),
        },
        {
          name: 'actions',
        },
      ],
      addingCustomerNote: false,
    };
  },
  methods: {
    async banCustomerFromCommunityGroup(communityGroupId) {
      await this.$store.dispatch('sale/banCustomerFromCommunityGroup', {
        communityGroupId,
        customerId: this.getUserId,
      });
      this.$refs['customer-groups-table'].refresh();
    },
    async unbanCustomerFromCommunityGroup(communityGroupId) {
      await this.$store.dispatch('sale/unbanCustomerFromCommunityGroup', {
        communityGroupId,
        customerId: this.getUserId,
      });
      this.$refs['customer-groups-table'].refresh();
    },
    viewGroup(data) {
      if (!data.active) return;
      const route = this.$router.resolve({
        name: 'studio-community-group',
        params: {
          group_id: data.id,
          studio_url: this.teacherStudioUrl,
        },
      });
      const routeUrl = route.href.replaceAll(`${this.teacherStudioUrl}/`, '');
      const url = getStudentViewURL(
        this.teacherStudioUrl,
        routeUrl,
        this.teacherMagicCode
      );

      window.open(url, '_blank');
    },
    getStatus(data) {
      return !(data.is_banned || data.is_self_banned);
    },
    getStatusText(data) {
      if (data.is_banned) {
        return this.$t('GENERAL.LABEL.BANNED');
      }
      if (data.is_self_banned) {
        return this.$t('GENERAL.LABEL.LEFT_GROUP');
      }
      return this.$t('GENERAL.LABEL.ACTIVE');
    },
  },
});
